import type { BuildOrganizationAppsPathParams } from '../types';

const buildOrganizationAppsPath = ({ organizationId }: BuildOrganizationAppsPathParams): string =>
    `/agents/${organizationId}/apps`;

export default buildOrganizationAppsPath;
